<template>
  <div id="app">
    <MVMHeader />
    <MVMTags @change="changeTags" />
    <MVMCases :filter="tags" />
    <MVMFooter />
    <router-view/>
  </div>
</template>
<script>
import MVMHeader from './components/MVMHeader'
import MVMTags from './components/MVMTags'
import MVMCases from './components/MVMCases'
import MVMFooter from './components/MVMFooter'

export default {
  components: {
    MVMHeader,
    MVMTags,
    MVMCases,
    MVMFooter
  },

  data () {
    return {
      tags: ['all'],
      scrollBarWidth: null
    }
  },

  provide () {
    return {
      sbWidth: this.getScrollbarWidth()
    }
  },

  created () {
    this.scrollBarWidth = this.getScrollbarWidth()
    this.watchForHover()
  },

  methods: {
    watchForHover () {
      var hasHoverClass = false
      var container = document.body
      var lastTouchTime = 0

      function enableHover () {
        // filter emulated events coming from touch events
        if (new Date() - lastTouchTime < 500) return
        if (hasHoverClass) return

        container.className += 'has-hover'
        hasHoverClass = true
      }

      function disableHover () {
        if (!hasHoverClass) return

        container.className = container.className.replace('has-hover', '')
        hasHoverClass = false
      }

      function updateLastTouchTime () {
        lastTouchTime = new Date()
      }

      document.addEventListener('touchstart', updateLastTouchTime, true)
      document.addEventListener('touchstart', disableHover, true)
      document.addEventListener('mousemove', enableHover, true)

      enableHover()
    },

    changeTags (newTags) {
      this.tags = newTags
    },

    getScrollbarWidth () {
      return window.innerWidth - document.documentElement.clientWidth
    },

    setDummyScroll () {
      document.documentElement.style.paddingRight = this.getScrollbarWidth()
    }
  }
}
</script>
